import React, { useState } from 'react';
import ForgotEmail from './ForgotEmail';
import ForgotEmailSuccess from './ForgotEmailSuccess';

export enum ForgotEmailFlowSteps {
    EMail = 0,
    Success = 1,
}

export const ForgotEmailFlow = () => {
  const [activeComponent, setActiveComponent] = useState<ForgotEmailFlowSteps>(ForgotEmailFlowSteps.EMail);
  switch (activeComponent) {
    case ForgotEmailFlowSteps.Success:
      return (
        <ForgotEmailSuccess />
      );
    default:
      return (
        <ForgotEmail onSubmit={() => setActiveComponent(ForgotEmailFlowSteps.Success)} />
      );
  }
};
